import React from 'react';
import Tracks from '../tracks/Tracks';
import Search from '../tracks/Search';

const Index = () => {
	return(
		<div>
		<Search />
		<Tracks/>
		</div>
		)
}

export default Index;